import React from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../ui/card";
import {
  CheckCircle,
  FileText,
  Tag,
  BarChart,
  FileUp,
  Filter,
  Download,
} from "lucide-react";

const TradingJournalGuide = () => {
  return (
    <Card className="intellectia-card border-market-teal/30">
      <CardHeader className="pb-2">
        <CardTitle className="text-xl flex items-center gap-2">
          <span className="text-market-teal">
            How to Use the Trading Journal
          </span>
        </CardTitle>
        <CardDescription>
          Logging your trades consistently is key to improving your trading
          performance
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="space-y-4">
            <h3 className="font-semibold text-market-teal flex items-center gap-2">
              <FileText className="h-5 w-5" />
              Logging Your Trades
            </h3>
            <ul className="space-y-3">
              {[
                "Click 'New Entry' to add a new trade",
                "Fill all required fields (stock, entry/exit, etc.)",
                "Add details about your strategy in 'Reason'",
                "P&L and ROI are calculated automatically",
                "Save entry to add it to your journal",
              ].map((item, index) => (
                <li key={index} className="flex items-start gap-2">
                  <CheckCircle className="h-4 w-4 text-market-teal mt-0.5 flex-shrink-0" />
                  <span className="text-white/80 text-sm">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="space-y-4">
            <h3 className="font-semibold text-market-teal flex items-center gap-2">
              <Tag className="h-5 w-5" />
              Using Tags & Screenshots
            </h3>
            <ul className="space-y-3">
              {[
                "Add tags to categorize trades by strategy",
                "Use common tags like 'ORB', 'Breakout', 'Retest'",
                "Upload chart screenshots for visual reference",
                "Choose 'Intraday' or 'Positional' trade type",
                "Add notes about market conditions",
              ].map((item, index) => (
                <li key={index} className="flex items-start gap-2">
                  <CheckCircle className="h-4 w-4 text-market-teal mt-0.5 flex-shrink-0" />
                  <span className="text-white/80 text-sm">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="space-y-4">
            <h3 className="font-semibold text-market-teal flex items-center gap-2">
              <BarChart className="h-5 w-5" />
              Analyzing Your Performance
            </h3>
            <ul className="space-y-3">
              {[
                "Review statistics to track your progress",
                "Filter entries by date, tag, or result",
                "Identify patterns in winning/losing trades",
                "Export data to Excel for deeper analysis",
                "Journal consistently for best results",
              ].map((item, index) => (
                <li key={index} className="flex items-start gap-2">
                  <CheckCircle className="h-4 w-4 text-market-teal mt-0.5 flex-shrink-0" />
                  <span className="text-white/80 text-sm">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-6 pt-6 border-t border-white/10">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="flex items-center gap-3 p-4 rounded-lg bg-white/5">
              <FileUp className="h-5 w-5 text-market-teal" />
              <div>
                <p className="font-medium">Upload Screenshots</p>
                <p className="text-sm text-white/60">
                  Visual reference of your setups
                </p>
              </div>
            </div>
            <div className="flex items-center gap-3 p-4 rounded-lg bg-white/5">
              <Filter className="h-5 w-5 text-market-teal" />
              <div>
                <p className="font-medium">Filter & Sort</p>
                <p className="text-sm text-white/60">
                  Organize by date, stock, or result
                </p>
              </div>
            </div>
            <div className="flex items-center gap-3 p-4 rounded-lg bg-white/5">
              <Download className="h-5 w-5 text-market-teal" />
              <div>
                <p className="font-medium">Export Data</p>
                <p className="text-sm text-white/60">
                  Download as Excel for analysis
                </p>
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default TradingJournalGuide;
